import { SxProps, Theme, Typography, useTheme } from "@mui/material";
import React, { ComponentProps } from "react";

type GradientTextProps = {
    children: React.ReactNode;
    variant?: ComponentProps<typeof Typography>["variant"];
    sx?: SxProps<Theme>;
};

function GradientText({ children, variant = "h1", sx = {} }: GradientTextProps) {
    const theme = useTheme();
    return (
        <Typography
            variant={variant}
            sx={{
                display: "flex",
                justifyContent: "center",
                background: `linear-gradient(90deg, ${theme.palette.primary.light}, ${theme.palette.alexxisTextGradientAccent})`,
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                color: "transparent",

                userSelect: "none",
                pointer: "default",
                ...sx // <-- Allow overrides from props
            }}
        >
            {children}
        </Typography>
    );
}

export default GradientText;
